var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.95752H513V342.961H0V0.95752Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 0.95752V118.513H210.341L256.5 149.293V171.954H233.828L160.312 122.939V171.954H96.1875V122.939L22.6722 171.954H0V149.293L46.159 118.513H0V54.3877H46.159L0 23.6187V0.95752H22.6722L96.1875 49.96V0.95752H160.312V49.96L233.828 0.95752H256.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.281 0.953613H112.219V70.422H0V102.485H112.219V171.954H144.281V102.485H256.5V70.422H144.281V0.953613Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.952637V16.0651L57.4891 54.3908H80.1562L0 0.952637ZM256.5 0.952637V16.0651L199.011 54.3908H176.344L256.5 0.952637Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 23.6187V54.3906H210.341L256.5 23.6187Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.952637V16.0651L57.4891 54.3908H80.1562L0 0.952637ZM256.5 0.952637V16.0651L199.011 54.3908H176.344L256.5 0.952637Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 23.6187V54.3906H210.341L256.5 23.6187Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 171.954V156.842L57.4891 118.516H80.1562L0 171.954ZM256.5 171.954V156.842L199.011 118.516H176.344L256.5 171.954Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.75 175.67L338.531 221.889C347.193 238.597 364.633 250.018 384.75 250.018C404.868 250.018 422.308 238.596 430.969 221.889L384.75 175.67Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.707 93.8887V175.672C332.708 215.509 384.75 227.715 384.75 227.715C384.75 227.715 436.793 215.509 436.794 175.671V93.8887H332.707Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.599 131.058H395.903V190.533H373.599V131.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.75 142.21C390.909 142.21 395.902 137.217 395.902 131.058C395.902 124.899 390.909 119.906 384.75 119.906C378.591 119.906 373.599 124.899 373.599 131.058C373.599 137.217 378.591 142.21 384.75 142.21Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.579 108.754H362.448V123.623H347.579V108.754ZM347.579 142.211H362.448V157.08H347.579V142.211ZM347.579 175.667H362.448V190.536H347.579V175.667ZM407.054 108.754H421.923V123.623H407.054V108.754ZM407.054 142.211H421.923V157.08H407.054V142.211ZM407.054 175.667H421.923V190.536H407.054V175.667Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.956543)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVg);
export default __webpack_public_path__ + "static/media/VG.5aa6e20c44da490540a74596645c8c2d.svg";
export { ForwardRef as ReactComponent };